<template>
    <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="d-none d-sm-none d-md-block col-md-4 selected">
              <span v-if="stakingHistory === 1">{{ $t('stakingHistory.communityStaking') }}</span>
              <span v-else>{{ $t('stakingHistory.myStaking') }}</span>
            </div>
            <div class="d-none d-sm-none d-md-block col-md-3 text-center select-type-history"
              @click="changeHistory">
              <span v-if="stakingHistory === 1">{{ $t('stakingHistory.myStaking') }}</span>
              <span v-else>{{ $t('stakingHistory.communityStaking') }}</span>
            </div>
            <div class="d-block d-sm-none col-12 pt-3 selected text-center">
              <span v-if="stakingHistory === 1">{{ $t('stakingHistory.communityStaking') }}</span>
              <span v-else>{{ $t('stakingHistory.myStaking') }}</span>
            </div>
            <div class="d-block d-sm-none col-12 pt-3 select-type-history text-center"
              @click="changeHistory">
              <span v-if="stakingHistory === 1">{{ $t('stakingHistory.myStaking') }}</span>
              <span v-else>{{ $t('stakingHistory.communityStaking') }}</span>
            </div>
          </div>
          <div class="row pt-2">
            <div class="table-responsive">
              <table class="table staking-history" v-if="stakingHistory == 1">
                <thead>
                  <tr>
                    <th scope="col" class="text-center">
                      {{ $t('stakingHistory.address') }}
                    </th>
                    <th scope="col" class="text-center">
                      {{ $t('stakingHistory.payoutType') }}
                    </th>
                    <th scope="col" class="text-center">
                      {{ $t('stakingHistory.reward') }}
                    </th>
                    <th scope="col" class="text-center">
                      {{ $t('stakingHistory.timeAgo') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(option, index) in history" :key="index">
                    <td>{{ option.address }}</td>
                    <td class="text-center">{{ option.payoutType }}</td>
                    <td class="text-center">{{ getReward(option.reward) }}</td>
                    <td class="text-center">{{ option.stakeDate }}</td>
                  </tr>
                </tbody>
              </table>
              <table class="table staking-history" v-if="stakingHistory == 2">
                <thead>
                  <tr>
                    <th scope="col" class="text-center" style="width: 40%">
                      {{ $t('stakingHistory.address') }}
                    </th>
                    <th scope="col" class="text-center" style="width: 30%">
                      {{ $t('stakingHistory.payoutType') }}
                    </th>
                    <th scope="col" class="text-center">
                      {{ $t('stakingHistory.reward') }}
                    </th>
                    <th scope="col" class="text-center" style="width: 30%">
                      {{ $t('stakingHistory.timeAgo') }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(option, index) in myHistory" :key="index">
                    <td>{{ option.address }}</td>
                    <td class="text-center">{{ option.payoutType }}</td>
                    <td class="text-center">{{ getReward(option.reward) }}</td>
                    <td class="text-center">{{ option.stakeDate }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import Swal from 'sweetalert2'

export default {
  computed: {
    history () {
      return this.$store.getters.getStakingHistory
    },
    myHistory () {
      let myHistory = []
      let history = this.$store.getters.getStakingHistory
      let address = this.$store.getters.getAddress

      if (typeof window.ethereum !== 'undefined') {
        myHistory = history.filter(function(option) {
          return option.address.toUpperCase() == address.toUpperCase()
        })
      } else {
        Swal.fire({
          title: 'Error',
          text: 'Metamask is not installed or not running',
          icon: 'error',
          confirmButtonText: 'Ok',
          footer: '<a href="https://metamask.io/download.html" target="_blank">Go to Metamask</a>'
        })
        this.stakingHistory = 1
      }

      return myHistory
    },
    surveyName () {
      return this.$store.getters.getSurveyName
    }
  },
  data () {
    return {
      stakingHistory: 1
    }
  },
  methods: {
    changeHistory () {
      this.stakingHistory = this.stakingHistory === 1? 2 : 1;
    },
    getReward (reward) {
      if (reward > 0) {
        return reward
      } else {
        return this.$t('stakingHistory.pending')
      }
    }
  },
  mounted () {
    const self = this

    setInterval(() => {
      self.$store.dispatch('getStakingHistory')      
    }, 30000)
  },
  watch: {
    async surveyName () {
      await this.$store.dispatch('getStakingHistory')
    }
  }
}
</script>

<style scoped>
.card {
  color: white;
  background: rgba(32,37,38, 0.6) 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 50px #0000001A;
  border-radius: 20px;
  backdrop-filter: blur(49px);
  -webkit-backdrop-filter: blur(49px);
}

.history-option {
  text-transform: none;
  border-radius: 10px;
  color: #72a5ad;
  background: rgb(26,59,83);
  background: linear-gradient(180deg, rgba(26,59,83,1) 30%, rgba(16,38,54,1) 100%);
  border: 1px solid rgba(255, 255, 255, 0.15);
  font-weight: 200;
  height: 110%;
  margin-top: 0;
  font-size: 12px;
}

.selected {
  padding-top: .6rem;
  padding-bottom: .6rem;
  font: normal normal 600 17px Poppins;
  letter-spacing: 0px;
  color: #fff;
}

.select-type-history {
  background: #212627 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 6px #00000029;
  border-radius: 9px;
  opacity: 1;
  padding-top: .7rem;
  padding-bottom: .7rem;
  font: normal normal normal 13px Poppins;
  letter-spacing: 0px;
  color: #fff;
  cursor: pointer;
}

.staking-history tbody {
	height: 100px !important;
	overflow-y: auto;
}

table {
  border: none;
}

thead {
  border-top: 1px solid  rgba(255,255,255,.05);
  border-bottom: 1px solid rgba(255,255,255,.05);
  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.4);
  text-align: left;
  font: normal normal normal 13px Poppins;
  letter-spacing: 0px;
  color: #A2A5B7;
  opacity: 1;
}

th {
  font-size: .8rem;
  border: none !important;
  padding-top: .6rem !important;
  padding-bottom: .4rem !important;
}

tbody {
  color: white;
}

td {
  border: none;
  padding-top: 1rem !important;
  padding-bottom: .1rem !important;
}
</style>
